var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewardbannerperson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 86,
    viewBox: "0 0 65 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2763 32.2805C47.5018 38.6703 53.1938 46.6574 58.9666 54.4157C60.5584 56.6506 62.5593 59.6931 62.4876 62.6183C60.4226 76.9563 42.1039 57.2403 39.1484 51.7009C39.595 45.2445 39.6885 38.6776 40.2763 32.2805Z",
    fill: "#E3AE99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6088 54.7216C50.5404 57.688 50.1396 60.7569 50.2426 63.9225C49.2628 63.244 48.4908 62.4631 47.6172 61.5782C48.5566 59.1057 49.9419 56.7384 51.6088 54.7216Z",
    fill: "#DD937C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.269 31.9314C45.0632 35.1114 48.8543 39.3016 52.1356 44.085C53.1024 44.2579 53.9786 44.9122 54.4448 45.8093C54.9107 46.7061 54.9562 47.8263 54.5645 48.7607C52.5873 53.4781 49.3692 57.5475 48.4888 62.6106C47.5755 63.1099 46.3584 63.4924 45.4821 62.9261C44.6058 62.3597 44.2288 60.9802 44.8875 60.1551C40.086 57.8399 36.3078 53.3383 34.7539 48.0815L40.269 31.9314Z",
    fill: "#008080"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8438 38.9163C46.2616 41.2017 48.4177 43.7864 50.2515 46.5978",
    stroke: "#098D83",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9258 48.1847C45.9202 48.6631 47.0628 49.5431 47.7925 50.3924",
    stroke: "#098D83",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2373 37.0349C45.1898 38.4071 44.5584 39.7947 44.2031 41.5065",
    stroke: "#098D83",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5977 51.1526C46.2833 47.5321 47.8514 44.4162 50.3221 41.7649",
    stroke: "#098D83",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.052 44.3141C48.9005 47.9616 46.4625 52.272 44.9297 56.9072",
    stroke: "#202020",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7177 30.9611C53.7379 38.4187 52.7581 45.8763 51.7783 53.3339C51.4791 55.6128 51.1791 57.9224 51.449 60.2053C51.7187 62.4883 52.6275 64.7801 54.3553 66.2184C56.0831 67.6566 58.7181 68.0259 60.5289 66.7023C62.1921 65.4865 62.8056 63.2514 63.1673 61.1723C64.8192 51.6778 63.5791 41.9279 62.3362 32.3663L54.7177 30.9611Z",
    fill: "#E3AE99"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7417 54.7217C51.6216 56.6129 51.5736 58.5219 51.9736 60.3712",
    stroke: "#202020",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7832 31.0615C53.6416 27.3686 55.8819 23.9616 56.1134 20.4171C56.0799 19.8591 55.981 19.1941 56.3928 18.8342C58.7336 17.9386 58.7087 22.5536 58.2296 23.9959C59.4262 23.2892 65.1688 23.4756 63.3012 25.852C64.5096 26.1927 64.6266 28.0546 63.4718 28.5559C64.8311 28.5386 65.1316 30.739 63.8445 31.1475C66.1689 32.2418 63.5978 33.985 62.0711 33.3234L54.7832 31.0615Z",
    fill: "#E3AE99"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9484 23.9039C58.3293 24.0737 57.9679 24.8506 58.1478 25.4888C58.3274 26.1274 58.9575 26.5682 59.5974 26.5964C59.244 26.7713 58.8799 26.9545 58.6247 27.2629C58.3695 27.5712 58.2523 28.0415 58.4529 28.3905C58.6614 28.7527 59.1119 28.8575 59.513 28.9243C58.9428 28.8478 58.3756 29.4045 58.4165 30.0003C58.4573 30.5962 59.095 31.0634 59.649 30.9035C59.187 31.0725 58.6766 31.361 58.6037 31.8643C58.5483 32.2472 58.7869 32.6252 59.1021 32.8316C59.4173 33.0377 59.7966 33.1056 60.1661 33.1554C60.8755 33.2512 61.591 33.297 62.3065 33.2927",
    stroke: "#202020",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4349 29.9786C58.4087 30.9725 57.9158 31.9418 57.1406 32.5249",
    stroke: "#202020",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4336 26.6279C60.7557 26.389 62.0751 26.135 63.3919 25.8658",
    stroke: "#202020",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5078 28.9243C60.8926 28.859 62.1178 28.7044 63.494 28.53",
    stroke: "#202020",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6484 30.9033C61.1152 30.9384 62.3468 31.0617 63.8133 31.0965",
    stroke: "#202020",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1158 78.805C46.2897 66.8761 45.145 54.9881 44.3189 43.0592C44.1138 40.098 43.5704 36.8062 42.2125 34.1331C37.987 27.5804 24.2629 28.6795 17.4989 29.9015C13.0142 30.7116 8.53202 30.8588 6.96079 35.6669C6.33436 37.7533 6.1474 40.8083 6.26437 42.99C6.93583 60.7622 7.30558 78.8821 3.61719 96.3403C3.64582 96.2195 3.67444 96.099 3.70307 95.9783L49.1185 97.9516C49.5296 93.8847 48.2608 90.1686 47.6287 86.2238C47.4582 83.7507 47.2871 81.2779 47.1158 78.805Z",
    fill: "#008080"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8372 45.2617L45.599 59.547L46.1812 66.5301L6.55859 70.389L6.60998 53.9545L13.8372 45.2617Z",
    fill: "#098D83"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1602 31.3164C24.3698 46.5316 25.1247 61.9745 24.4097 77.344",
    stroke: "#098D83",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8829 78.9804C35.6743 63.0639 34.6544 47.0513 31.8516 31.3818",
    stroke: "#098D83",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1186 79.5192C41.6898 63.4487 41.0174 47.1433 38.1289 31.2712",
    stroke: "#098D83",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.668 31.671C16.8593 36.108 16.9308 43.8074 16.6205 50.251C16.2786 59.7999 16.1237 69.3823 15.5795 78.916",
    stroke: "#098D83",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58867 48.7756C9.47302 59.7605 9.32278 70.8348 8.14062 81.7894",
    stroke: "#098D83",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4414 41.3586C25.3647 42.3169 34.7549 41.4321 43.7677 40.2394",
    stroke: "#098D83",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6289 48.4579C25.5347 49.9983 35.0746 49.3178 44.6848 46.3849",
    stroke: "#098D83",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39062 67.7215C20.0608 70.643 33.5211 69.764 45.7393 65.2174",
    stroke: "#098D83",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9336 35.7382C24.1009 34.8162 34.0032 34.5157 43.1998 35.033",
    stroke: "#098D83",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9844 32.2037C28.0674 36.2729 28.6875 40.475 28.8277 44.6944",
    stroke: "#202020",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M46.015 62.929C45.4023 54.7217 44.9229 46.877 43.7188 38.4343",
    stroke: "#202020",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1046 20.9076C24.7681 20.899 24.4321 20.9201 24.0967 20.9851C23.1188 23.6374 23.5816 27.8444 20.7139 29.1962C19.6438 29.3873 21.7142 30.8553 22.1072 30.9992C23.1888 31.6306 24.4138 32.0157 25.6691 32.0183C27.7094 32.0699 30.2866 31.1029 31.0714 29.0399C27.9059 28.0843 29.8983 23.9277 29.6952 21.4973C28.1565 21.5909 26.6252 20.9465 25.1046 20.9076Z",
    fill: "#E3AE99"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4294 26.7353C26.27 27.1987 27.3251 27.3024 28.1566 26.8217C29.0677 26.2948 29.5639 25.099 29.3821 24.0144C29.2003 22.9297 28.3894 22.0108 27.4008 21.6753C26.4765 21.3616 25.4157 21.5436 24.6322 22.1503C24.0364 22.6117 23.6123 23.3095 23.4425 24.0698C23.36 24.4396 23.3691 24.6366 23.5886 24.9292C23.8386 25.263 24.0767 25.5998 24.3645 25.8997C24.6807 26.2289 25.0357 26.5182 25.4294 26.7353Z",
    fill: "#DD937C"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2725 29.645C24.7584 30.2335 25.2745 30.6834 25.5395 30.8944C26.0125 31.2708 26.5213 31.6148 27.0205 31.9485C25.8799 32.432 24.9586 33.3143 24.4986 34.3642C21.2599 33.3466 19.7049 30.643 20.2405 28.8745C20.668 27.4632 22.3633 26.8572 22.7583 26.7266C23.1884 28.1895 23.8494 29.1328 24.2725 29.645Z",
    fill: "#008080"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6765 29.4885C28.3731 30.3004 28.1325 30.6792 28.0214 30.8493C27.7434 31.2758 27.4023 31.6657 26.9883 31.9924C27.6556 32.2051 28.9581 32.9217 29.4434 33.7509C31.2684 32.8963 32.2518 30.9209 31.7671 29.3165C31.2574 27.6296 29.459 27.0892 29.3218 27.0503C29.1507 28.0874 28.893 28.9092 28.6765 29.4885Z",
    fill: "#008080"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9531 33.7508C25.4467 32.9448 26.1536 32.3932 26.9883 31.9923C27.8205 32.2409 28.9095 32.9628 29.4123 33.6657",
    stroke: "#202020",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1043 20.3144C21.7588 24.9705 27.6456 25.454 31.5953 24.049C37.7192 21.6934 36.7913 9.68541 33.3297 6.75783C23.4964 -1.55871 15.9569 11.326 20.1043 20.3144Z",
    fill: "#E3AE99"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1022 24.4554C17.3069 22.3537 16.013 10.8274 20.4846 12.9792C21.53 18.4881 22.708 18.6963 25.6148 18.1203C27.7268 17.7019 29.8983 17.7172 31.9991 18.1928C34.4368 18.7446 36.1708 18.5219 36.0548 14.2677C38.8209 23.2736 30.6251 27.1837 23.1022 24.4554Z",
    fill: "#202020"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5362 15.7508C21.645 15.2322 22.5056 12.876 22.0033 10.8786C25.7961 12.2223 35.7379 13.7332 38.4024 10.0471C38.8776 7.83406 36.6523 6.02241 34.7018 5.44055C36.8919 4.1228 35.8027 0.961609 33.3914 0.878995C31.8148 0.774775 30.4883 1.89553 28.9897 2.35689C26.5178 3.11821 23.6457 2.05465 21.2628 3.02568C19.3869 3.79031 18.2679 5.85591 18.7375 7.68688C15.0241 9.23519 15.2732 15.5985 19.5362 15.7508Z",
    fill: "#202020"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7978 7.84937C20.0008 8.72761 20.6955 10.3044 20.5491 11.8242C20.4028 13.3441 19.4208 14.7465 18.0742 15.3596",
    stroke: "#4E4E4E",
    strokeWidth: 0.190645,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M18.707 7.77431C19.5769 8.71306 20.8403 9.12105 22.0604 9.42379C24.2153 9.95862 26.4195 10.2774 28.6329 10.3745C30.1111 10.4393 31.6194 10.4009 33.0265 9.92583C33.6551 9.71358 34.2666 9.4088 34.7502 8.94057C35.2339 8.47234 35.5804 7.82592 35.6042 7.13959C35.6279 6.45326 35.2897 5.741 34.701 5.42859",
    stroke: "#4E4E4E",
    strokeWidth: 0.190645,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5469 7.77874C22.5274 8.76197 26.9406 7.96964 30.2111 5.41573C30.8289 4.93327 31.4238 4.36539 31.7155 3.62187C32.0072 2.87834 31.9181 1.92333 31.3272 1.40527",
    stroke: "#4E4E4E",
    strokeWidth: 0.190645,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0859 14.8945C28.4214 14.5925 28.9823 14.6405 29.2923 14.9705C29.6024 15.3007 29.6462 15.8523 29.4247 16.2519C29.2032 16.6517 28.7501 16.8869 28.3062 16.8729",
    stroke: "#202020",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4207 15.7609C25.606 15.7759 25.7912 15.6879 25.9207 15.5494C26.0501 15.4109 26.1274 15.2263 26.1634 15.0367C26.2038 14.8237 26.1928 14.5959 26.1044 14.3989C25.8964 13.9358 25.1653 13.8079 24.9176 14.3018C24.6803 14.7756 24.7838 15.709 25.4207 15.7609Z",
    fill: "#202020"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5106 15.6889C31.6959 15.7039 31.8811 15.6159 32.0106 15.4774C32.14 15.3388 32.2174 15.1543 32.2531 14.9647C32.2935 14.7516 32.2824 14.5239 32.1941 14.3271C31.9861 13.864 31.2549 13.7361 31.0073 14.23C30.7702 14.7036 30.8737 15.637 31.5106 15.6889Z",
    fill: "#202020"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2509 20.3144C20.9722 22.0892 23.173 22.8899 23.5161 20.9461C23.821 19.2193 21.5644 18.3197 21.2509 20.3144Z",
    fill: "#DD937C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9682 20.3313C32.6899 22.1061 34.6593 22.7904 35.2334 20.963C35.7578 19.2937 33.2809 18.3364 32.9682 20.3313Z",
    fill: "#DD937C"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1419 21.2526C29.3388 21.4892 28.4892 21.6054 27.666 21.4602C26.8428 21.3151 26.0468 20.8888 25.5469 20.1941",
    stroke: "white",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3387 16.1825C20.3805 16.8704 20.4691 17.5941 20.3323 18.2705C19.2835 19.1416 17.232 19.059 16.4614 17.7768C15.2954 15.8226 16.8502 13.5035 18.9967 13.7031C20.267 13.6517 20.1804 15.2511 20.3387 16.1825Z",
    fill: "#E3AE99"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0702 14.9496C17.7666 15.1148 17.5593 15.4394 17.4832 15.7866C17.365 16.3268 17.5615 16.9282 17.9719 17.2818C18.1713 17.4537 18.4214 17.5698 18.6805 17.5767C18.9397 17.5836 19.2059 17.4725 19.3659 17.2605C19.4369 17.1664 19.4873 17.0462 19.467 16.9285C19.4354 16.7457 19.2527 16.6374 19.0816 16.5836C18.9106 16.5297 18.7219 16.4987 18.5922 16.371C18.4762 16.2569 18.43 16.0724 18.4774 15.9137C18.5249 15.7554 18.6639 15.6306 18.8217 15.6049C18.8934 15.5932 18.97 15.5998 19.0351 15.566C19.2695 15.4442 19.1279 15.0652 18.9548 14.9575C18.6942 14.795 18.3343 14.806 18.0702 14.9496Z",
    fill: "#DD937C"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75883 39.7828C1.25358 48.1942 4.55926 60.0326 11.5215 64.5418C19.8724 69.9501 35.3229 62.8005 45.408 61.8857C45.3855 61.1541 44.8501 52.4649 44.5653 52.4682C36.0284 52.564 27.4866 52.2064 18.9849 51.3973C17.307 45.7188 15.1818 40.1832 12.6386 34.8631C10.6802 29.4408 4.5316 36.7873 3.75883 39.7828Z",
    fill: "#E3AE99"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9461 51.3977C17.1897 53.2399 15.4285 55.0876 13.8962 57.1344C12.3639 59.1812 11.1218 61.2356 10.3789 63.711C8.69874 62.2989 7.40403 60.7298 6.98828 59.4669C7.00345 59.5002 7.01838 59.5335 7.03355 59.5666C7.53935 58.2361 8.38088 56.989 9.40153 56.0287C10.4222 55.0683 11.5946 54.2976 12.7995 53.6046C14.7331 52.4925 16.7472 51.6311 18.9461 51.3977Z",
    fill: "#DD937C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6758 52.4956C43.3999 50.3766 46.0607 49.8552 46.5979 52.3631C48.175 51.8288 49.7756 54.0002 47.9014 54.807C49.442 54.5546 49.5169 57.1959 47.9376 56.885C49.5734 56.7963 49.3197 59.2671 47.9114 59.4773C48.5905 59.4921 48.9825 60.6299 48.5085 61.0999C47.2417 61.4684 45.738 61.8586 44.4173 61.9865",
    fill: "#E3AE99"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9247 54.7728C47.4497 54.8318 46.975 54.8908 46.5 54.9497",
    stroke: "#202020",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2992 56.9109C47.8854 56.8784 47.4667 56.9114 47.0625 57.009",
    stroke: "#202020",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9598 59.4921C47.6803 59.5284 47.4006 59.565 47.1211 59.6014",
    stroke: "#202020",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87367 41.1959C1.48866 45.9267 2.34267 51.139 4.46962 55.4814C3.53755 57.892 5.24703 60.7825 7.73785 61.0087C9.53004 58.198 12.0179 55.8391 14.6849 53.926C16.192 52.6339 18.354 52.2181 19.6196 50.6662C20.6371 48.9659 19.1329 47.2872 17.5389 46.8794C16.5398 42.0512 14.8533 37.5031 12.1283 33.4604C8.5116 29.2359 3.76292 38.1605 2.87367 41.1959Z",
    fill: "#008080"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2129 34.9409C9.50756 37.26 10.6787 44.6261 11.5462 48.9794C11.5092 48.8676 11.472 48.7555 11.4348 48.6434",
    stroke: "#098D83",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4093 31.6329C3.98158 34.6861 2.72993 45.9508 5.88951 52.7152",
    stroke: "#098D83",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5625 49.5075C5.36752 45.369 11.5257 42.1631 16.5665 43.9198",
    stroke: "#098D83",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17578 38.2531C7.63586 36.9468 11.9639 37.7768 14.9427 40.0244",
    stroke: "#098D83",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55859 55.295C4.7798 54.9874 4.92368 54.7085 5.08005 54.3687C5.24473 54.0105 5.55306 53.7111 5.80828 53.4208C6.36082 52.7921 6.95153 52.1996 7.57381 51.6455C8.82081 50.5346 10.1931 49.5776 11.6452 48.7809C12.6484 48.2303 13.6904 47.7563 14.759 47.36C15.5976 47.0491 16.4861 46.7812 17.368 46.9103C18.1023 47.0178 18.7951 47.4085 19.2816 47.9899C19.6765 48.4616 19.9383 49.0707 19.9315 49.696C19.9244 50.3214 19.6241 50.9535 19.1073 51.2743",
    stroke: "#202020",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6081 46.7728C16.9051 43.7493 15.7993 40.8271 14.332 38.1158",
    stroke: "#202020",
    strokeWidth: 0.254194,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8812 77.0115L0.285156 87.8332L24.9764 86.5483L52.2698 85.1279L60.4487 75.3365L22.8812 77.0115Z",
    fill: "#3D2F28"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6769 81.4154C22.6769 81.4154 23.3559 81.0028 23.4474 80.3418C23.4474 80.3418 23.7567 81.3139 24.2214 81.5474L23.579 82.8054L22.7143 82.0394L22.6769 81.4154Z",
    fill: "#B7304A"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M22.712 81.9511C22.712 81.9511 23.3911 81.5386 23.4826 80.8776C23.4826 80.8776 23.7918 81.8497 24.2566 82.0832L23.6141 83.3411L22.7494 82.5752L22.712 81.9511Z",
    fill: "#FFC05F"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M23.616 82.4487C23.5456 82.3612 23.4607 80.9692 21.7109 80.8196C21.7109 80.8196 22.8209 81.7291 22.1154 82.6105C21.1558 83.8094 23.616 82.4487 23.616 82.4487Z",
    fill: "#CC3A52"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2898 82.2825C23.374 82.2082 23.6937 80.8507 25.4434 81.0003C25.4434 81.0003 24.1954 81.7082 24.7412 82.6965C25.4837 84.041 23.2898 82.2825 23.2898 82.2825Z",
    fill: "#E85877"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8932 87.7525C28.6047 91.1318 25.8199 92.8559 22.5898 92.5797C19.3597 92.3036 16.9074 90.1317 17.1959 86.7524C17.4844 83.3731 20.2748 81.5844 23.5049 81.8605C26.735 82.1367 29.1817 84.3732 28.8932 87.7525Z",
    fill: "#E9435A"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8191 86.3081C27.6708 88.0452 26.2393 88.9314 24.5789 88.7894C22.9185 88.6475 21.6581 87.5311 21.8064 85.794C21.9547 84.057 23.3889 83.1375 25.0493 83.2795C26.7097 83.4215 27.9674 84.571 27.8191 86.3081Z",
    fill: "#E85877"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2921 85.6503C27.2054 86.6662 26.3682 87.1846 25.3972 87.1015C24.4262 87.0185 23.6889 86.3656 23.7757 85.3497C23.8624 84.3338 24.7013 83.7961 25.6723 83.8791C26.6433 83.9621 27.3788 84.6345 27.2921 85.6503Z",
    fill: "#ED698B"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7222 90.8688C21.0328 90.6388 18.9912 88.8306 19.2314 86.0171C19.4573 83.3704 21.5266 81.8961 24.0098 81.9219C23.8437 81.8965 23.6756 81.8751 23.5049 81.8605C20.2748 81.5844 17.4844 83.3731 17.1959 86.7524C16.9074 90.1317 19.3597 92.3036 22.5898 92.5797C25.8199 92.8559 28.6047 91.1318 28.8932 87.7525C28.9069 87.5927 28.9124 87.4363 28.9141 87.2816C28.4837 89.8088 26.2699 91.0866 23.7222 90.8688Z",
    fill: "#CC3A52"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3961 81.1952C48.3961 81.1952 49.1817 80.7179 49.2876 79.9532C49.2876 79.9532 49.6454 81.0778 50.1831 81.348L49.4398 82.8034L48.4394 81.9172L48.3961 81.1952Z",
    fill: "#B7304A"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4274 81.8151C48.4274 81.8151 49.2129 81.3378 49.3188 80.573C49.3188 80.573 49.6766 81.6977 50.2143 81.9679L49.471 83.4232L48.4706 82.5371L48.4274 81.8151Z",
    fill: "#FFC05F"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4775 82.3908C49.396 82.2896 49.2978 80.679 47.2734 80.506C47.2734 80.506 48.5576 81.5582 47.7414 82.5779C46.6311 83.965 49.4775 82.3908 49.4775 82.3908Z",
    fill: "#CC3A52"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0984 82.1985C49.1959 82.1126 49.5657 80.5421 51.59 80.7151C51.59 80.7151 50.1461 81.5341 50.7776 82.6776C51.6366 84.2331 49.0984 82.1985 49.0984 82.1985Z",
    fill: "#E85877"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5865 88.5272C55.2527 92.4368 52.0308 94.4315 48.2937 94.112C44.5567 93.7925 41.7196 91.2798 42.0534 87.3701C42.3871 83.4604 45.6154 81.391 49.3525 81.7105C53.0896 82.03 55.9203 84.6175 55.5865 88.5272Z",
    fill: "#E9435A"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3389 86.8556C54.1673 88.8653 52.5112 89.8906 50.5902 89.7264C48.6692 89.5621 47.2109 88.2706 47.3825 86.2609C47.5541 84.2512 49.2135 83.1875 51.1344 83.3517C53.0554 83.5159 54.5104 84.8459 54.3389 86.8556Z",
    fill: "#E85877"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7363 86.0947C53.636 87.2701 52.6674 87.8697 51.544 87.7737C50.4206 87.6776 49.5677 86.9223 49.668 85.7469C49.7684 84.5715 50.7389 83.9494 51.8623 84.0455C52.9857 84.1415 53.8367 84.9194 53.7363 86.0947Z",
    fill: "#ED698B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6038 92.1325C46.4925 91.8665 44.1304 89.7745 44.4083 86.5194C44.6697 83.4574 47.0637 81.7517 49.9366 81.7815C49.7445 81.752 49.55 81.7274 49.3525 81.7105C45.6154 81.391 42.3871 83.4604 42.0534 87.3701C41.7196 91.2798 44.5567 93.7925 48.2937 94.112C52.0308 94.4315 55.2527 92.4368 55.5865 88.5272C55.6023 88.3422 55.6087 88.1613 55.6106 87.9824C55.1127 90.9062 52.5515 92.3845 49.6038 92.1325Z",
    fill: "#CC3A52"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3475 91.969C20.1202 91.696 17.6723 89.5244 17.9642 86.1412C18.0862 84.728 18.6451 83.5933 19.4886 82.7696C18.2258 83.5975 17.3604 84.9489 17.2048 86.752C16.9128 90.1352 19.3608 92.3068 22.5881 92.5798C24.4865 92.7404 26.2309 92.2075 27.4057 91.0535C26.2953 91.7801 24.8709 92.0978 23.3475 91.969Z",
    fill: "#AF2E47"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5228 79.3293C35.5228 79.3293 36.5125 78.7274 36.6462 77.7635C36.6462 77.7635 37.0964 79.1808 37.7735 79.5211L36.8367 81.3556L35.577 80.2392L35.5228 79.3293Z",
    fill: "#B7304A"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5697 80.1104C35.5697 80.1104 36.5594 79.5085 36.6931 78.5447C36.6931 78.5447 37.1432 79.9619 37.8204 80.3022L36.8836 82.1367L35.6239 81.0203L35.5697 80.1104Z",
    fill: "#FFC05F"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M36.885 80.8351C36.7824 80.7075 36.6594 78.6776 34.1094 78.4603C34.1094 78.4603 35.7266 79.786 34.698 81.0717C33.2988 82.8204 36.885 80.8351 36.885 80.8351Z",
    fill: "#CC3A52"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4158 80.5938C36.5386 80.4855 37.0052 78.5058 39.5551 78.7231C39.5551 78.7231 37.7359 79.756 38.5309 81.197C39.6123 83.1571 36.4158 80.5938 36.4158 80.5938Z",
    fill: "#E85877"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5856 88.5651C44.1635 93.4933 40.1038 96.009 35.3961 95.6078C30.6883 95.2066 27.1153 92.0405 27.5374 87.1123C27.9595 82.1841 32.0273 79.5742 36.735 79.9754C41.4428 80.3766 45.0077 83.6369 44.5856 88.5651Z",
    fill: "#E9435A"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0147 86.4604C42.7977 88.9937 40.7109 90.2868 38.291 90.0805C35.8711 89.8743 34.0345 88.2469 34.2514 85.7137C34.4684 83.1804 36.5593 81.8389 38.9793 82.0451C41.3992 82.2514 43.2316 83.9272 43.0147 86.4604Z",
    fill: "#E85877"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2467 85.5023C42.1198 86.9838 40.8994 87.7401 39.4842 87.6195C38.069 87.4989 36.9948 86.5471 37.1217 85.0655C37.2486 83.584 38.4715 82.7994 39.8867 82.92C41.3019 83.0406 42.3736 84.0208 42.2467 85.5023Z",
    fill: "#ED698B"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0473 93.112C33.1278 92.778 30.153 90.142 30.5044 86.0389C30.835 82.1792 33.8517 80.0282 37.4709 80.0645C37.2288 80.0275 36.9839 79.9965 36.735 79.9753C32.0273 79.5741 27.9595 82.184 27.5374 87.1122C27.1153 92.0404 30.6883 95.2065 35.3961 95.6077C40.1038 96.0088 44.1635 93.4932 44.5856 88.565C44.6056 88.3319 44.6138 88.1038 44.6162 87.8783C43.9877 91.5639 40.7605 93.4284 37.0473 93.112Z",
    fill: "#CC3A52"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5038 94.7163C31.8004 94.3201 28.234 91.1545 28.6615 86.2202C28.8401 84.1591 29.6554 82.5039 30.8852 81.3022C29.0443 82.5103 27.7822 84.4817 27.5543 87.1114C27.1268 92.0457 30.6932 95.2113 35.3966 95.6076C38.1632 95.8406 40.706 95.0625 42.4188 93.3788C40.7999 94.4392 38.7239 94.9033 36.5038 94.7163Z",
    fill: "#AF2E47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardbannerperson);
export default __webpack_public_path__ + "static/media/rewardbannerperson.dc50218f38f3fd8888d238bf78c865c9.svg";
export { ForwardRef as ReactComponent };